const SAFE_NAME_REGEX = /^(?=.{2,50}$)[A-Za-z]+(?: [A-Za-z]+)*$/;
const INDIAN_MOBILE_REGEX = /^[6-9]\d{9}$/;

export const INVALID_NAME_MESSAGE =
  "Enter Valid Name";

export const normalizeName = (value = "") => value.trim().replace(/\s+/g, " ");

export const sanitizeNameInput = (value = "") =>
  value
    .replace(/[^A-Za-z ]/g, "")
    .replace(/\s{2,}/g, " ")
    .slice(0, 50);

export const isValidSafeName = (value = "") =>
  SAFE_NAME_REGEX.test(normalizeName(value));

export const normalizeIndianMobile = (value = "") => {
  const digits = String(value).replace(/\D/g, "");

  return digits.startsWith("91") && digits.length === 12
    ? digits.slice(2)
    : digits.slice(0, 10);
};

export const isValidIndianMobile = (value = "") =>
  INDIAN_MOBILE_REGEX.test(value);
